import { AbstractControl, ValidationErrors } from '@angular/forms';

import { digitsOnly as digitsOnlyHelper } from 'helpers';

export function digitsOnly(control: AbstractControl): ValidationErrors | null {
  if (!control.value || control.value.toString().length === 0) {
    return null;
  }

  const digits = digitsOnlyHelper(control.value);
  const isDigitsOnly = digits.toString().length === control.value.toString().length;

  if (isDigitsOnly) {
    return null;
  }

  return {digitsOnly: true};

}
